export default __webpack_public_path__ + "media/color/wabi-1baff376.svg";